import { PulseLoader } from "react-spinners";

const LoadingScreen = () => {
	return (
		<div className="min-h-screen flex items-center justify-center bg-gray-50">
			<div className="text-center">
				{/* Logo */}
				<div className="mb-4">
					<h1 className="text-2xl font-bold text-gray-900">BBMA Sparepart</h1>
				</div>
				<div className="flex justify-center mb-4">
					<PulseLoader color="#2563eb" size={15} margin={5} />
				</div>
				{/* Loading text */}
				<div className="text-sm text-gray-500">Loading...</div>
			</div>
		</div>
	);
};

export default LoadingScreen;
